export default "__VITE_ASSET__xio2fWvA__"